<template>
  <div class="toast-container">
    <transition-group name="toast-fade" tag="div">
      <BackstageToastMessage
        v-for="toast in toasts"
        :key="toast.id"
        :message="toast.options.message"
        @close="removeToast(toast.id as string)" />
    </transition-group>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import type { Toast, ToastOptions } from '../../plugins/toast/types';
import BackstageToastMessage from './BackstageToastMessage.vue';

const DEFAULT_DURATION = 3000; // default 3s

const toasts = ref<Toast[]>([]);

const showToast = (options: ToastOptions) => {
  const id = `toast_${Date.now()}_${Math.random()}`;
  toasts.value.push({ id, options });

  const duration = options.duration || DEFAULT_DURATION;
  if (duration > 0) {
    setTimeout(() => removeToast(id), duration);
  }
};

const removeToast = (id: string) => {
  toasts.value = toasts.value.filter((t) => t.id !== id);
};

defineExpose({
  showToast,
  removeToast,
});
</script>

<style scoped>
.toast-container {
  position: fixed;
  bottom: 1.5rem;
  right: 1.5rem;
  z-index: 9999;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}

/* Simple fade transition */
.toast-fade-enter-active,
.toast-fade-leave-active {
  transition:
    opacity 0.4s ease,
    transform 0.4s ease;
}
.toast-fade-enter-from {
  opacity: 0;
  transform: translateY(15px);
}
.toast-fade-leave-to {
  opacity: 0;
  transform: translateY(-15px);
}
</style>
